<template>
<div class="chapter">
<div class="inner_page">
<div class="hide"> </div>
<div class="hide"> </div>
<div class="hide"> </div>
<div class="hide"><hr/></div>
<p class="h2p"><a id="page_17"></a><span class="br">ONE</span></p>
<div class="hide"><hr/></div>
<p class="h2pa">Uprooted</p>
<p class="h2pc">When Life’s Landscape Changes</p>
<p class="center">I pray that out of his glorious riches he may strengthen you with power through his Spirit in your inner being, so that Christ may dwell in your hearts through faith. And I pray that you, being rooted and established in love, may have power, together with all the Lord’s holy people, to grasp how wide and long and high and deep is the love of Christ.</p>
<p class="centers">EPHESIANS 3:16–18</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Part01.vue?310d17e5